import {useEnvironment} from "@common-core/react-runtime/context";
import {TabColumn} from "../../../tab-content";
import {EmbeddedComponentLoader} from "../../../pbc";
import {FC} from "react";
import {Environment} from "../../../runtime";
import "./CommentsColumn.scss";
import {useTranslation} from "react-i18next";

export const CommentsColumn: FC<{
  commonOrgId: string;
}> = ({commonOrgId}) => {
  const environment = useEnvironment<Environment>();
  const {t} = useTranslation();
  return (
    <TabColumn
      className={"comments-column"}
      name={"comments-column"}
      header={<h3>{t("entity-detail.comments")}</h3>}>
      <EmbeddedComponentLoader
        component={environment.contextualCommentsComponent}
        attributes={{
          "reference-id": commonOrgId,
          "link": window.location.href
        }}
      />
    </TabColumn>
  );
};
